module.exports = __webpack_public_path__ + "static/media/belgium-logo.8ca8138f.mp4";